/**
 * Deleting a job with a live Vonq campaign needs a warning either way: when
 * Vonq removal is automatic the delete cancels the campaign for good, and when
 * it is not, the job page is the only place the campaign can be stopped from.
 */
export const PLAIN_DELETE_MESSAGE = 'Are you sure you want to delete this job?';

export const VONQ_CAMPAIGN_DELETE_MESSAGE =
  'This job has an active Vonq campaign. Once the job is deleted, the campaign can no longer be stopped from {app}. Stop it first from the job distribution page. Delete the job anyway?';

export const VONQ_CAMPAIGN_AUTO_STOP_DELETE_MESSAGE =
  'This job has an active Vonq campaign. Deleting the job will also stop the campaign, and a stopped campaign cannot be reactivated. Delete the job anyway?';

export function jobDeleteConfirmationMessage(job, isVonqAutoRemoveEnabled = false) {
  if (!job?.has_active_vonq_campaign) {
    return PLAIN_DELETE_MESSAGE;
  }

  return isVonqAutoRemoveEnabled ? VONQ_CAMPAIGN_AUTO_STOP_DELETE_MESSAGE : VONQ_CAMPAIGN_DELETE_MESSAGE;
}
